<ng-container *ngIf="{ articleRefs: articleRefs$ | async, componentData: componentData$ | async } as data">
  <ng-container *ngIf="data.componentData?.tileTitle">
    <h1 *ngIf="getHasClass('h1', data.componentData.styleClasses)">{{ data.componentData.tileTitle }}</h1>
    <h2 *ngIf="getHasClass('h2', data.componentData.styleClasses)">{{ data.componentData.tileTitle }}</h2>
    <h3 *ngIf="getHasClass('h3', data.componentData.styleClasses)">{{ data.componentData.tileTitle }}</h3>
    <h4 *ngIf="getHasClass('h4', data.componentData.styleClasses)">{{ data.componentData.tileTitle }}</h4>
    <h5 *ngIf="getHasClass('h5', data.componentData.styleClasses)">{{ data.componentData.tileTitle }}</h5>
    <h6 *ngIf="getHasClass('h6', data.componentData.styleClasses)">{{ data.componentData.tileTitle }}</h6>

    <h2 *ngIf="getHasNoTitleClass(data.componentData.styleClasses)" class="mb-4">{{ data.componentData.tileTitle }}</h2>
  </ng-container>
  <ng-container *ngIf="data.articleRefs?.length && data.componentData">
    <ng-container *ngIf="data.componentData.displayMode === displayModeSlider; else displayModeGrid">
      <py-article-carousel
        [carouselItems]="articles$ | async"
        [useDefaultArticleQuantityAndUnit]="true"
        [carouselActionMode]="carouselActionModes.ADD_TO_CART_MODE"
        [hideOverflow]="true"
        [enableSecondaryArticleRowVariant]="enableSecondaryArticleRowVariant$ | async"
      >
      </py-article-carousel>
    </ng-container>
    <ng-template #displayModeGrid>
      <py-catalog-article-list [articleRefs]="data.articleRefs"></py-catalog-article-list>
    </ng-template>
  </ng-container>
</ng-container>
